import React from 'react';
import { Heading, Text } from '../common/Typography';

const steps = [
  {
    number: '1',
    title: 'Create your account',
    description: 'Sign up as a player. The same account works if you also host or help run a club.',
  },
  {
    number: '2',
    title: 'Join a club or set up a session',
    description: 'Players request to join and sign up for games. Organisers plan sessions, take sign-ups, and open courts.',
  },
  {
    number: '3',
    title: 'Play, then see how it went',
    description: 'Matchmaking fills courts with more even, varied games. Results feed into history, club Elo, and leaderboards.',
  },
];

const LandingHowItWorks = () => (
  <section id="how-it-works" className="scroll-mt-24 px-4 py-12 sm:px-6 md:scroll-mt-8 lg:px-10 lg:py-16">
    <div className="mx-auto max-w-app-shell">
      <Heading level={2} className="mb-8 text-center text-3xl sm:text-4xl">How it works</Heading>
      <ol className="grid gap-4 sm:grid-cols-3 sm:gap-6">
        {steps.map((step) => (
          <li key={step.number} className="rounded-2xl border border-border-medium bg-surface p-6 shadow-brand-sm">
            <div className="mb-2 flex items-start gap-3">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary text-sm font-bold text-text-inverse">
                {step.number}
              </span>
              <Heading level={3} className="pt-1.5 text-lg">{step.title}</Heading>
            </div>
            <Text className="text-sm text-text-secondary">{step.description}</Text>
          </li>
        ))}
      </ol>
    </div>
  </section>
);

export default LandingHowItWorks;
